(function () {
  if (window.__productVideoModalInit) return;
  window.__productVideoModalInit = true;

  function parseVideo(url) {
    if (!url) return null;
    var cleanUrl = String(url).trim();

    var yt = cleanUrl.match(/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([A-Za-z0-9_-]{6,})/);
    if (yt && yt[1]) return { type: 'youtube', id: yt[1] };

    var vm = cleanUrl.match(/vimeo\.com\/(?:video\/)?(\d+)/);
    if (vm && vm[1]) return { type: 'vimeo', id: vm[1] };

    var m = cleanUrl.match(/\.(mp4|webm|ogg)(\?|#|$)/i);
    if (m && m[1]) {
      var ext = m[1].toLowerCase();
      var mime = ext === 'mp4' ? 'video/mp4' : (ext === 'webm' ? 'video/webm' : 'video/ogg');
      return { type: 'html5', src: cleanUrl, mime: mime };
    }

    return { type: 'url', src: cleanUrl };
  }

  function destroyPlayer(container) {
    if (!container) return;
    try {
      if (container.__plyr) {
        container.__plyr.destroy();
        container.__plyr = null;
      }
    } catch (e) {}
    container.innerHTML = '';
  }

  function initPlayer(container, info) {
    if (!container || !info) return;

    destroyPlayer(container);

    var el;

    if (info.type === 'youtube' || info.type === 'vimeo') {
      el = document.createElement('div');
      el.setAttribute('data-plyr-provider', info.type);
      el.setAttribute('data-plyr-embed-id', info.id);
      container.appendChild(el);
    } else if (info.type === 'html5') {
      el = document.createElement('video');
      el.setAttribute('playsinline', '');
      el.setAttribute('controls', '');
      var source = document.createElement('source');
      source.src = info.src;
      source.type = info.mime;
      el.appendChild(source);
      container.appendChild(el);
    } else {
      el = document.createElement('iframe');
      el.src = info.src;
      el.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture');
      el.setAttribute('allowfullscreen', '');
      container.appendChild(el);
      return;
    }

    if (!window.Plyr) return;

    var player = new Plyr(el, {
      controls: ['play-large','play','progress','current-time','mute','volume','fullscreen'],
      ratio: '9:16',
      fullscreen: { enabled: true, fallback: true, iosNative: true }
    });

    container.__plyr = player;

    setTimeout(function () {
      try { player.play(); } catch (e) {}
    }, 50);
  }

  /* -------------------------------
     Docking behavior helpers
  -------------------------------- */

  function isOnScreenVert(rect) {
    return rect.bottom > 0 && rect.top < window.innerHeight;
  }

  function setupDockingButton() {
    var galleries = document.querySelectorAll('product-gallery');
    if (!galleries || !galleries.length) return;

    galleries.forEach(function (gallery) {
      var btn = gallery.querySelector('[data-product-video-trigger]');
      if (!btn) return;

      var carousel = gallery.querySelector('.product-gallery__carousel');
      if (!carousel) return;

      var items = carousel.querySelectorAll('.product-gallery__media');
      if (!items || !items.length) return;

      var firstMedia = items[0];

      // robust active index for scroll-carousel: measure overlap
      function getActiveIndexFromViewport() {
        var c = carousel.getBoundingClientRect();
        var bestIdx = 0;
        var bestOverlap = -Infinity;

        for (var i = 0; i < items.length; i++) {
          var r = items[i].getBoundingClientRect();
          var overlap = Math.min(r.right, c.right) - Math.max(r.left, c.left);
          if (overlap > bestOverlap) {
            bestOverlap = overlap;
            bestIdx = i;
          }
        }
        return bestIdx;
      }

      function update() {
        var activeIdx = getActiveIndexFromViewport();
        var rect = firstMedia.getBoundingClientRect();

        // Only on first slide + when first image is still on screen vertically
        var shouldShow = (activeIdx === 0) && isOnScreenVert(rect);
        btn.classList.toggle('is-hidden', !shouldShow);

        if (!shouldShow) return;

        var rightOffset = Math.round(window.innerWidth - rect.right + 18);
        if (!isFinite(rightOffset) || rightOffset < 18) rightOffset = 18;
        btn.style.setProperty('--watch-video-inline-end', rightOffset + 'px');

        var dockInset = 18; 
        btn.style.setProperty('--watch-video-docked-inline-end', dockInset + 'px');

        btn.classList.add('is-ready');

        var dock = rect.bottom <= (window.innerHeight - 18);
        btn.classList.toggle('is-docked-to-media', dock);
      }

      requestAnimationFrame(update);

      var rafW = null;
      window.addEventListener('scroll', function () {
        if (rafW) return;
        rafW = requestAnimationFrame(function () {
          rafW = null;
          update();
        });
      }, { passive: true });

      var rafC = null;
      carousel.addEventListener('scroll', function () {
        if (rafC) return;
        rafC = requestAnimationFrame(function () {
          rafC = null;
          update();
        });
      }, { passive: true });

      window.addEventListener('resize', update, { passive: true });
    });
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target && e.target.closest ? e.target.closest('[data-product-video-trigger]') : null;
    if (!trigger) return;

    var modalId = trigger.getAttribute('aria-controls');
    if (!modalId) return;

    var modal = document.getElementById(modalId);
    if (!modal) return;

    var container = modal.querySelector('[data-product-video-container]');
    if (!container) return;

    var url = trigger.getAttribute('data-video-url');
    if (!url) return;

    var info = parseVideo(url);
    initPlayer(container, info);
  }, true);

  document.addEventListener('toggle', function (e) {
    var dialog = e.target;
    if (!dialog || !dialog.matches || !dialog.matches('x-modal[data-product-video-modal]')) return;

    if (!dialog.hasAttribute('open')) {
      var container = dialog.querySelector('[data-product-video-container]');
      destroyPlayer(container);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupDockingButton);
  } else {
    setupDockingButton();
  }
})();
